import SEOHead from '@/components/SEOHead';
import LegalDocument from '@/components/LegalDocument';

const content = {
  'zh-TW': {
    title: '服務條款',
    updated: '最後更新日期：2026 年 10 月',
    intro: '歡迎瀏覽埵智有限公司（DZent Limited，以下簡稱「本公司」、「我們」）的官方網站（dzentlimited.com）。您使用本網站即表示您同意遵守以下服務條款。如您不同意本條款的任何部分，請停止使用本網站。',
    sections: [
      {
        heading: '1. 條款的接受',
        paragraphs: [
          '本服務條款構成您與埵智有限公司之間具法律約束力的協議。我們保留隨時修訂本條款的權利，修訂後的條款將於本頁面公佈並即時生效。您於條款修訂後繼續使用本網站，即視為接受修訂後的條款。',
        ],
      },
      {
        heading: '2. 網站的使用',
        paragraphs: ['您同意僅將本網站用於合法用途，並且不會：'],
        items: [
          '以任何可能損害、停用或妨礙本網站正常運作的方式使用本網站；',
          '未經授權嘗試存取本網站的伺服器、資料庫或相關系統；',
          '透過聯絡表格發送垃圾訊息、惡意內容或虛假資料；',
          '以任何自動化方式（如爬蟲、機械人）大量抓取本網站內容作商業用途。',
        ],
      },
      {
        heading: '3. 知識產權',
        paragraphs: [
          '本網站所有內容，包括但不限於文字、圖像、標誌、產品名稱、設計及程式碼，均屬埵智有限公司或其授權人所有，受香港及國際知識產權法律保護。未經本公司事先書面同意，任何人不得複製、修改、分發或以其他方式使用本網站的內容。',
        ],
      },
      {
        heading: '4. 產品與服務',
        paragraphs: [
          '本網站介紹的產品與服務由本公司開發及營運。各產品的使用受該產品內列明的個別使用條款及私隱政策約束。其中「LC Shield」（getlcshield.com）受其自身的使用條款及私隱政策約束：https://getlcshield.com/terms 及 https://getlcshield.com/privacy。本網站顯示的產品資訊僅供參考，本公司保留隨時更改的權利。',
        ],
      },
      {
        heading: '5. 免責聲明',
        paragraphs: [
          '本網站的內容按「現狀」提供。在法律允許的最大範圍內，本公司不就本網站內容的準確性、完整性或適時性作出任何明示或暗示的保證。本公司會盡力確保網站持續可用，但不保證網站運作不會中斷或完全無誤。',
        ],
      },
      {
        heading: '6. 責任限制',
        paragraphs: [
          '在法律允許的最大範圍內，對於因使用或無法使用本網站而引致的任何直接、間接、附帶或衍生性損失，本公司概不負責。',
        ],
      },
      {
        heading: '7. 第三方連結',
        paragraphs: [
          '本網站可能包含指向第三方網站的連結（如應用商店）。該等網站不受本公司控制，本公司對其內容、私隱政策或運作概不負責。',
        ],
      },
      {
        heading: '8. 適用法律與管轄權',
        paragraphs: [
          '本條款受中華人民共和國香港特別行政區法律管轄並按其詮釋。因本條款引起的任何爭議，雙方同意接受香港法院的專屬管轄。',
        ],
      },
      {
        heading: '9. 聯絡我們',
        paragraphs: [
          '如對本服務條款有任何疑問，歡迎電郵至 info@dzentlimited.com 與我們聯絡。',
        ],
      },
    ],
  },
  'zh-CN': {
    title: '服务条款',
    updated: '最后更新日期：2026 年 10 月',
    intro: '欢迎浏览埵智有限公司（DZent Limited，以下简称「本公司」、「我们」）的官方网站（dzentlimited.com）。您使用本网站即表示您同意遵守以下服务条款。如您不同意本条款的任何部分，请停止使用本网站。',
    sections: [
      {
        heading: '1. 条款的接受',
        paragraphs: [
          '本服务条款构成您与埵智有限公司之间具法律约束力的协议。我们保留随时修订本条款的权利，修订后的条款将于本页面公布并即时生效。您于条款修订后继续使用本网站，即视为接受修订后的条款。',
        ],
      },
      {
        heading: '2. 网站的使用',
        paragraphs: ['您同意仅将本网站用于合法用途，并且不会：'],
        items: [
          '以任何可能损害、停用或妨碍本网站正常运作的方式使用本网站；',
          '未经授权尝试访问本网站的服务器、数据库或相关系统；',
          '通过联系表格发送垃圾信息、恶意内容或虚假资料；',
          '以任何自动化方式（如爬虫、机器人）大量抓取本网站内容作商业用途。',
        ],
      },
      {
        heading: '3. 知识产权',
        paragraphs: [
          '本网站所有内容，包括但不限于文字、图像、标志、产品名称、设计及代码，均属埵智有限公司或其授权人所有，受香港及国际知识产权法律保护。未经本公司事先书面同意，任何人不得复制、修改、分发或以其他方式使用本网站的内容。',
        ],
      },
      {
        heading: '4. 产品与服务',
        paragraphs: [
          '本网站介绍的产品与服务由本公司开发及运营。各产品的使用受该产品内列明的个别使用条款及隐私政策约束。其中「LC Shield」（getlcshield.com）受其自身的使用条款及隐私政策约束：https://getlcshield.com/terms 及 https://getlcshield.com/privacy。本网站显示的产品信息仅供参考，本公司保留随时更改的权利。',
        ],
      },
      {
        heading: '5. 免责声明',
        paragraphs: [
          '本网站的内容按「现状」提供。在法律允许的最大范围内，本公司不就本网站内容的准确性、完整性或适时性作出任何明示或暗示的保证。本公司会尽力确保网站持续可用，但不保证网站运作不会中断或完全无误。',
        ],
      },
      {
        heading: '6. 责任限制',
        paragraphs: [
          '在法律允许的最大范围内，对于因使用或无法使用本网站而引致的任何直接、间接、附带或衍生性损失，本公司概不负责。',
        ],
      },
      {
        heading: '7. 第三方链接',
        paragraphs: [
          '本网站可能包含指向第三方网站的链接（如应用商店）。该等网站不受本公司控制，本公司对其内容、隐私政策或运作概不负责。',
        ],
      },
      {
        heading: '8. 适用法律与管辖权',
        paragraphs: [
          '本条款受中华人民共和国香港特别行政区法律管辖并按其诠释。因本条款引起的任何争议，双方同意接受香港法院的专属管辖。',
        ],
      },
      {
        heading: '9. 联系我们',
        paragraphs: [
          '如对本服务条款有任何疑问，欢迎电邮至 info@dzentlimited.com 与我们联系。',
        ],
      },
    ],
  },
  en: {
    title: 'Terms of Service',
    updated: 'Last updated: October 2026',
    intro: 'Welcome to the official website (dzentlimited.com) of DZent Limited ("the Company", "we", "us"). By using this website, you agree to be bound by the following Terms of Service. If you do not agree with any part of these terms, please discontinue use of this website.',
    sections: [
      {
        heading: '1. Acceptance of Terms',
        paragraphs: [
          'These Terms of Service constitute a legally binding agreement between you and DZent Limited. We reserve the right to revise these terms at any time. Revised terms will be posted on this page and take effect immediately. Your continued use of this website after any revision constitutes acceptance of the revised terms.',
        ],
      },
      {
        heading: '2. Use of the Website',
        paragraphs: ['You agree to use this website only for lawful purposes and will not:'],
        items: [
          'Use the website in any way that may damage, disable, or impair its normal operation;',
          'Attempt unauthorized access to the website servers, databases, or related systems;',
          'Submit spam, malicious content, or false information through the contact form;',
          'Use any automated means (such as crawlers or bots) to scrape website content in bulk for commercial purposes.',
        ],
      },
      {
        heading: '3. Intellectual Property',
        paragraphs: [
          'All content on this website, including but not limited to text, images, logos, product names, designs, and code, is owned by DZent Limited or its licensors and protected by Hong Kong and international intellectual property laws. No content may be copied, modified, distributed, or otherwise used without the prior written consent of the Company.',
        ],
      },
      {
        heading: '4. Products and Services',
        paragraphs: [
          'The products and services presented on this website are developed and operated by the Company. The use of each product is governed by the individual terms of use and privacy policy stated within that product. In particular, LC Shield (getlcshield.com) is governed by its own terms and privacy policy: https://getlcshield.com/terms and https://getlcshield.com/privacy. Product information displayed on this website is for reference only, and the Company reserves the right to make changes at any time.',
        ],
      },
      {
        heading: '5. Disclaimer',
        paragraphs: [
          'The content of this website is provided "as is". To the maximum extent permitted by law, the Company makes no express or implied warranties regarding the accuracy, completeness, or timeliness of the website content. While we strive to keep the website continuously available, we do not guarantee uninterrupted or error-free operation.',
        ],
      },
      {
        heading: '6. Limitation of Liability',
        paragraphs: [
          'To the maximum extent permitted by law, the Company shall not be liable for any direct, indirect, incidental, or consequential losses arising from the use of, or inability to use, this website.',
        ],
      },
      {
        heading: '7. Third-Party Links',
        paragraphs: [
          'This website may contain links to third-party websites (such as app stores). Such websites are not controlled by the Company, and the Company is not responsible for their content, privacy policies, or operation.',
        ],
      },
      {
        heading: '8. Governing Law and Jurisdiction',
        paragraphs: [
          'These terms are governed by and construed in accordance with the laws of the Hong Kong Special Administrative Region of the People\'s Republic of China. Any dispute arising from these terms shall be subject to the exclusive jurisdiction of the Hong Kong courts.',
        ],
      },
      {
        heading: '9. Contact Us',
        paragraphs: [
          'If you have any questions about these Terms of Service, please contact us at info@dzentlimited.com.',
        ],
      },
    ],
  },
};

export default function TermsPage() {
  return (
    <>
      <SEOHead path="/terms" />
      <LegalDocument content={content} testId="terms-page" />
    </>
  );
}
